var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"min-vh-100"},[(_vm.token)?_c('Topbar'):_vm._e(),_c('div',{staticClass:"app container-fluid"},[_c('main',[_c('vue-confirm-dialog'),_c('router-view'),_c('edit-password-modal')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }